import {
  getItem,
  parseStoredString,
  removeItem,
  setItem,
} from '@core/storage/localStorage'
import { StorageKeyEssentialEnum } from '@core/storage/types'

export const CONVERSATION_KEY = StorageKeyEssentialEnum.fw_otoconv

export const CONVERSATION_EXPIRATION = 120 * 60 * 1000

/** Persists the conversation id in local storage. */
export function setConversation(id: string) {
  setItem(CONVERSATION_KEY, id, new Date(Date.now() + CONVERSATION_EXPIRATION))
}

/** Removes the persisted conversation. */
export function removeConversation() {
  removeItem(CONVERSATION_KEY)
}

/**
 * @returns The conversation id in local storage. Undefined if no conversation.
 */
export function getConversation(): string | undefined {
  return getItem(CONVERSATION_KEY)
}

/** Subscribe to conversation change. */
export function onConversationChange(
  callback: (newId: string | undefined) => void,
) {
  const onStorageEvent = (ev: StorageEvent) => {
    if (ev.key === CONVERSATION_KEY) {
      const value = parseStoredString(ev.newValue) as string | undefined
      callback(value)
    }
  }

  window.addEventListener('storage', onStorageEvent)
  return () => window.removeEventListener('storage', onStorageEvent)
}
